<template>
  <v-layout align-start>
    <v-flex xs12>
      <v-snackbar
        v-model="snackbar"
        :color="snackColor"
        :right="true"
        :bottom="true"
        :timeout="4000"
      >
        {{ snackText }}
        <template #action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
            Cerrar
          </v-btn>
        </template>
      </v-snackbar>

      <v-card elevation="0">
        <v-toolbar color="primary" dark>
          <v-toolbar-title style="font-weight: 500">
            Dashboard Becas Externas
          </v-toolbar-title>

          <div class="mt-6 ml-3" style="width: 180px">
            <v-autocomplete
              v-model="selectCiclo"
              :items="cmbCiclos"
              color="primary"
              item-text="nombre"
              item-value="nombre"
              label="Ciclo"
              no-data-text="Sin resultados"
              placeholder="Seleccionar..."
              dense
            />
          </div>
          <div class="mt-6 ml-3" style="width: 320px">
            <v-autocomplete
              v-model="selectInstitucion"
              :items="cmbInstituciones"
              color="primary"
              item-text="nombre"
              item-value="institucionPatrocinadoraId"
              label="Institución"
              no-data-text="Sin resultados"
              placeholder="Todas"
              clearable
              dense
            />
          </div>
          <div class="mt-6 ml-3" style="width: 160px">
            <v-select
              v-model="selectActivo"
              :items="cmbActivo"
              color="primary"
              item-text="label"
              item-value="value"
              label="Estado"
              dense
            />
          </div>


          <v-spacer />

<!-- BOTON REFRESCAR -->
<v-tooltip bottom color="primary">
  <template #activator="{ on, attrs }">
    <v-btn
      icon
      v-bind="attrs"
      v-on="on"
      :loading="loading"
      :disabled="!selectCiclo || loading"
      @click="refrescarDashboard"
    >
      <v-icon>fa-sync-alt</v-icon>
    </v-btn>
  </template>
  <span>Refrescar dashboard</span>
</v-tooltip>

          <v-tooltip bottom color="primary">
            <template #activator="{ on, attrs }">
          <ReportesSolicitudesDialog
            :ciclo="selectCiclo"
            :carreras="carrerasDisponibles"
            :instituciones="cmbInstituciones"
            :loading="generandoReporte"
            :activo-inicial="selectActivo"
            @reporte-completo="onReporteCompleto"
          />

            </template>
            <span>Descarga un reporte con los datos del ciclo seleccionado</span>
          </v-tooltip>
        </v-toolbar>

        <v-container fluid>
          <!-- KPIs -->
          <v-row>
            <v-col cols="12" sm="6" md="4" lg="2">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Total becarios</div>
                <div class="text-h4 font-weight-bold">{{ kpi.total }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-card class="pa-4" outlined color="green lighten-5">
                <div class="text-subtitle-2 success--text">Activos</div>
                <div class="text-h4 font-weight-bold success--text">{{ kpi.activos }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="2">
              <v-card class="pa-4" outlined color="red lighten-5">
                <div class="text-subtitle-2 error--text">Inactivos</div>
                <div class="text-h4 font-weight-bold error--text">{{ kpi.inactivos }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Instituciones</div>
                <div class="text-h4 font-weight-bold">{{ kpi.instituciones }}</div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="6" md="4" lg="3">
              <v-card class="pa-4" outlined>
                <div class="text-subtitle-2">Carreras</div>
                <div class="text-h4 font-weight-bold">{{ kpi.carreras }}</div>
              </v-card>
            </v-col>

        
          </v-row>

          <!-- Gráficas (placeholder simple con tablas + barras visuales) -->
          <v-row>
            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Instituciones ({{ selectCiclo || '—' }})
                </div>

                <v-skeleton-loader v-if="loading" type="list-item@5" />

                <div v-else>
                  <div v-if="chartInstituciones.length === 0" class="text-body-2">
                    No hay datos para graficar.
                  </div>

                  <div v-for="row in chartInstituciones" :key="row.label" class="mb-2">
                    <div class="d-flex justify-space-between">
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                    <v-progress-linear
                      :value="row.pct"
                      height="10"
                      rounded
                    />
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="6">
              <v-card outlined class="pa-3">
                <div class="text-subtitle-1 font-weight-medium mb-2">
                  Carreras ({{ selectCiclo || '—' }})
                </div>

                <v-skeleton-loader v-if="loading" type="list-item@5" />

                <div v-else>
                  <div v-if="chartCarreras.length === 0" class="text-body-2">
                    No hay datos para graficar.
                  </div>

                  <div v-for="row in chartCarreras" :key="row.label" class="mb-2">
                    <div class="d-flex justify-space-between">
                      <span>{{ row.label }}</span>
                      <strong>{{ row.value }}</strong>
                    </div>
                    <v-progress-linear
                      :value="row.pct"
                      height="10"
                      rounded
                    />
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <!-- Detalle / Listado -->
          </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../../helpers'
import ReportesSolicitudesDialog from './ReportesSolicitudesDialog.vue'
import ExcelJS from 'exceljs'


export default {
  name: 'DashboardBecasExternas',
  components: { ReportesSolicitudesDialog },
  computed: { ...authComputed,

     carrerasDisponibles() {
    const base = this.becasAll || []
    const set = new Set()

    base.forEach(b => {
      const carrera = (b?.carrera || '').toString().trim()
      if (carrera) set.add(carrera)
    })

    return Array.from(set).sort((a, b) => a.localeCompare(b))
  }

   },

  data: () => ({
    // UI
    loading: false,
    snackbar: false,
    snackText: '',
    snackColor: 'primary',
    generandoReporte: false,

    // Filtros
    cmbCiclos: [],
    selectCiclo: '',

    cmbInstituciones: [],
    selectInstitucion: null, // null = Todas

    selectActivo: 'todos', // activos | inactivos | todos (default: activos)
    cmbActivo: [
      { label: 'Activos', value: 'activos' },
      { label: 'Inactivos', value: 'inactivos' },
      { label: 'Todos', value: 'todos' }
    ],

    // Datos
    becasAll: [], // datos del ciclo (sin filtrar)
    becas: [],    // datos filtrados

    // KPIs
    kpi: {
      total: 0,
      activos: 0,
      inactivos: 0,
      instituciones: 0,
      carreras: 0,
    },

    // Charts (top 8)
    chartInstituciones: [],
    chartCarreras: []
  }),

  watch: {
    selectCiclo() {
      this.cargarDashboard()
    },
    selectInstitucion() {
      this.recalcularDashboard()
    },
    selectActivo() {
      this.recalcularDashboard()
    }
  },

  created() {
    // Validando acceso (misma idea que tu componente actual)
    if (this.permController && this.permController(11, 'ver')) {
      this.cargarCiclos()
      this.cargarInstituciones()
    } else {
      this.$router.push({ name: 'inicio' })
    }
  },

  methods: {
   // helpers de estilo ExcelJS
   _estiloTitulo(color) {
     return {
       font:      { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 },
       fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: color } },
       alignment: { vertical: 'middle', horizontal: 'left' },
       border: {
         bottom: { style: 'medium', color: { argb: 'FF' + color.substring(2) } }
       }
     }
   },
   _estiloHeader() {
     return {
       font:      { bold: true, color: { argb: 'FF1F3864' }, size: 10 },
       fill:      { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCDD7E8' } },
       alignment: { vertical: 'middle', horizontal: 'center' },
       border: {
         bottom: { style: 'thin', color: { argb: 'FF1F3864' } }
       }
     }
   },
   _estiloFila(par, inactivo = false) {
     if (inactivo) return {
       fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6B8B7' } },
       font: { size: 10, color: { argb: 'FF000000' } },
       alignment: { vertical: 'middle' }
     }
     return {
       fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: par ? 'FFFFFFFF' : 'FFF5F7FA' } },
       font: { size: 10 },
       alignment: { vertical: 'middle' }
     }
   },
   _anchos() {
     return [16, 35, 15, 30, 16, 45]
   },
   _aplicarAnchos(ws) {
     ws.columns = this._anchos().map(w => ({ width: w }))
   },
   _agregarHeaderConEstilo(ws, headers) {
     const row = ws.addRow(headers)
     row.height = 18
     row.eachCell(cell => Object.assign(cell, this._estiloHeader()))
     return row
   },
async refrescarDashboard() {
  if (!this.selectCiclo) return

  // opcional: limpia filtros de institución al refrescar
  // this.selectInstitucion = null

  this.loading = true
  try {
    const { data } = await axios.get('api/BecarioExterno?Ciclo=' + this.selectCiclo)
    this.becasAll = (data || []).map((b) => ({
      ...b,
      carrera: b.carreraCodigo === '3803' ? 'LICENCIATURA EN GASTRONOMIA Y HOSTELERIA' : b.carrera
    }))
    this.recalcularDashboard()

    this.snackText = 'Dashboard actualizado'
    this.snackColor = 'snackSuccess'
    this.snackbar = true
  } catch (e) {
    console.log(e)
    this.snackText = 'No se pudo refrescar el dashboard'
    this.snackColor = 'snackError'
    this.snackbar = true
  } finally {
    this.loading = false
  }
},


  async onReporteCompleto(payload) {
    if (!this.selectCiclo) return
    try {
      this.generandoReporte = true
      let rows = (this.becasAll || []).slice()

      // Filtro activo/inactivo/todos
      const estadoFiltro = payload?.activo || 'activos'
      if (estadoFiltro === 'activos')        rows = rows.filter(r => r.activo !== false)
      else if (estadoFiltro === 'inactivos') rows = rows.filter(r => r.activo === false)

      if (payload?.filtro === 'career' && payload?.carrera)
        rows = rows.filter(r => (r.carrera || '') === payload.carrera)

      if (payload?.filtro === 'institution' && payload?.institucionId) {
        const hasId = rows.length > 0 && Object.prototype.hasOwnProperty.call(rows[0], 'institucionPatrocinadoraId')
        if (hasId) {
          rows = rows.filter(r => r.institucionPatrocinadoraId === payload.institucionId)
        } else {
          const instName = this.cmbInstituciones.find(x => x.institucionPatrocinadoraId === payload.institucionId)?.nombre || ''
          rows = rows.filter(r => (r.institucionPatrocinadora || '') === instName)
        }
      }

      const HEADERS = ['Carnet', 'Nombre', 'Periodo Lectivo', 'Institución', 'Fecha Adjunto', 'Carrera']
      const toRow   = r => [
        (r.carnet ?? '').toString(),
        (r.nombre ?? '').toString(),
        (r.ciclo ?? r.periodoLectivo ?? this.selectCiclo ?? '').toString(),
        (r.institucionPatrocinadora ?? '').toString(),
        (r.fecha ?? r.fechaAdjunto ?? '').toString(),
        (r.carrera ?? '').toString()
      ]
      const safeKey = v => ((v ?? '').toString().trim() || 'Sin dato')
      const groupBy = (arr, fn) => {
        const m = new Map()
        for (const it of arr) { const k = safeKey(fn(it)); if (!m.has(k)) m.set(k, []); m.get(k).push(it) }
        return m
      }

      const wb = new ExcelJS.Workbook()
      wb.creator = 'Colecturía Digital'
      wb.created  = new Date()

      // ── COLORES ────────────────────────────────────────────────
      const COLOR_DATOS      = 'FF1F3864' // azul oscuro  — Datos Completos
      const COLOR_RESUMEN    = 'FF1E6B3A' // verde oscuro  — Resumen por carrera
      const COLOR_CARRERAS   = 'FF7B3F00' // café          — Bloques por carrera
      const COLOR_INST       = 'FF6A0572' // morado        — Bloques por institución

      // ── 1) Hoja: Datos Completos ────────────────────────────────
      const HEADERS_DATOS = [...HEADERS, 'Estado']
      const toRowDatos = r => [
        ...toRow(r),
        r.activo === false ? 'Inactivo' : 'Activo'
      ]

      const wsDatos = wb.addWorksheet('Datos Completos')
      wsDatos.columns = [...this._anchos().map(w => ({ width: w })), { width: 14 }]

      const titDatos = wsDatos.addRow([`Becas Externas — ${this.selectCiclo} — Datos completos (${rows.length} registros)`])
      titDatos.height = 22
      wsDatos.mergeCells(`A${titDatos.number}:G${titDatos.number}`)
      Object.assign(titDatos.getCell('A'), this._estiloTitulo(COLOR_DATOS))

      this._agregarHeaderConEstilo(wsDatos, HEADERS_DATOS)
      rows.forEach((r, i) => {
        const dr = wsDatos.addRow(toRowDatos(r))
        dr.eachCell(cell => Object.assign(cell, this._estiloFila(i % 2 === 0, r.activo === false)))
      })

      // ── 2) Hoja: Resumen por Carrera ───────────────────────────
      const byCarrera = groupBy(rows, r => r.carrera)
      const wsResumen = wb.addWorksheet('Resumen por Carrera')
      wsResumen.columns = [{ width: 50 }, { width: 16 }]

      const titRes = wsResumen.addRow([`Resumen por carrera — ${this.selectCiclo}`])
      titRes.height = 22
      wsResumen.mergeCells(`A${titRes.number}:B${titRes.number}`)
      Object.assign(titRes.getCell('A'), this._estiloTitulo(COLOR_RESUMEN))

      const hRes = wsResumen.addRow(['Carrera', 'Total alumnos'])
      hRes.height = 18
      hRes.eachCell(cell => Object.assign(cell, this._estiloHeader()))

      Array.from(byCarrera.entries())
        .sort((a, b) => b[1].length - a[1].length)
        .forEach(([carrera, items], i) => {
          const rr = wsResumen.addRow([carrera, items.length])
          rr.eachCell(cell => Object.assign(cell, this._estiloFila(i % 2 === 0)))
        })

      // ── 3) Hoja: Por Carrera (bloques) ─────────────────────────
      const wsCarreras = wb.addWorksheet('Por Carrera')
      wsCarreras.columns = [...this._anchos().map(w => ({ width: w })), { width: 14 }]

      Array.from(byCarrera.entries())
        .sort((a, b) => a[0].localeCompare(b[0]))
        .forEach(([carrera, items]) => {
          const titRow = wsCarreras.addRow([`Carrera: ${carrera} (${items.length})`])
          titRow.height = 20
          wsCarreras.mergeCells(`A${titRow.number}:G${titRow.number}`)
          Object.assign(titRow.getCell('A'), this._estiloTitulo(COLOR_CARRERAS))

          this._agregarHeaderConEstilo(wsCarreras, HEADERS_DATOS)
          items.forEach((r, i) => {
            const dr = wsCarreras.addRow(toRowDatos(r))
            dr.eachCell(cell => Object.assign(cell, this._estiloFila(i % 2 === 0, r.activo === false)))
          })
          wsCarreras.addRow([]) // separador
        })

      // ── 4) Hoja: Por Institución (bloques) ─────────────────────
      const byInst   = groupBy(rows, r => r.institucionPatrocinadora)
      const wsInst   = wb.addWorksheet('Por Institución')
      wsInst.columns = [...this._anchos().map(w => ({ width: w })), { width: 14 }]

      Array.from(byInst.entries())
        .sort((a, b) => a[0].localeCompare(b[0]))
        .forEach(([inst, items]) => {
          const titRow = wsInst.addRow([`Institución: ${inst} (${items.length})`])
          titRow.height = 20
          wsInst.mergeCells(`A${titRow.number}:G${titRow.number}`)
          Object.assign(titRow.getCell('A'), this._estiloTitulo(COLOR_INST))

          this._agregarHeaderConEstilo(wsInst, HEADERS_DATOS)
          items.forEach((r, i) => {
            const dr = wsInst.addRow(toRowDatos(r))
            dr.eachCell(cell => Object.assign(cell, this._estiloFila(i % 2 === 0, r.activo === false)))
          })
          wsInst.addRow([]) // separador
        })

      // ── Descargar ───────────────────────────────────────────────
      const today    = new Date()
      const fecha    = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,'0')}-${String(today.getDate()).padStart(2,'0')}`
      const estadoLabel = estadoFiltro === 'activos' ? 'Activos' : estadoFiltro === 'inactivos' ? 'Inactivos' : 'Todos'
      const filename = `Reporte_Becas_Externas_${this.selectCiclo}_${estadoLabel}_${fecha}.xlsx`

      const buffer = await wb.xlsx.writeBuffer()
      const blob   = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url    = URL.createObjectURL(blob)
      const a      = document.createElement('a')
      a.href = url; a.download = filename; a.click()
      URL.revokeObjectURL(url)

      this.snackText = 'Reporte completo generado'
      this.snackColor = 'snackSuccess'
      this.snackbar = true
    } catch (e) {
      console.log(e)
      this.snackText = 'No se pudo generar el reporte completo'
      this.snackColor = 'snackError'
      this.snackbar = true
    } finally {
      this.generandoReporte = false
    }
  },



   
groupAll(items, key, sortBy = 'label') {
  const map = new Map()
  for (const it of items) {
    const k = (it?.[key] || 'Sin dato').toString().trim() || 'Sin dato'
    map.set(k, (map.get(k) || 0) + 1)
  }

  let rows = Array.from(map.entries()).map(([label, value]) => ({ label, value }))

  if (sortBy === 'value') {
    rows.sort((a, b) => b.value - a.value)
  } else {
    rows.sort((a, b) => a.label.localeCompare(b.label))
  }

  const max = rows[0]?.value || 0
  return rows.map(r => ({
    ...r,
    pct: max ? Math.round((r.value / max) * 100) : 0
  }))
},


    async cargarCiclos() {
      try {
        const { data } = await axios.get('api/Ciclos')
        this.cmbCiclos = data || []
        this.selectCiclo = this.cmbCiclos?.[0]?.nombre || ''
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando ciclos'
        this.snackColor = 'snackError'
        this.snackbar = true
      }
    },

    async cargarInstituciones() {
      try {
        const { data } = await axios.get('api/InstitucionPatrocinadora')
        this.cmbInstituciones = data || []
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando instituciones'
        this.snackColor = 'snackError'
        this.snackbar = true
      }
    },

    async cargarDashboard() {
      if (!this.selectCiclo) return

      this.loading = true
      try {
        const { data } = await axios.get(
          'api/BecarioExterno?Ciclo=' + this.selectCiclo
        )
        this.becasAll = (data || []).map((b) => ({
          ...b,
          carrera: b.carreraCodigo === '3803' ? 'LICENCIATURA EN GASTRONOMIA Y HOSTELERIA' : b.carrera
        }))
        this.recalcularDashboard()
      } catch (e) {
        console.log(e)
        this.snackText = 'Error cargando becarios externos'
        this.snackColor = 'snackError'
        this.snackbar = true
      } finally {
        this.loading = false
      }
    },

    recalcularDashboard() {
      if (!this.selectCiclo) {
        this.becasAll = []
        this.becas = []
        this.kpi = { total: 0, activos: 0, inactivos: 0, instituciones: 0, carreras: 0 }
        this.chartInstituciones = []
        this.chartCarreras = []
        return
      }

      let base = this.becasAll || []

      // Filtro activo/inactivo/todos
      if (this.selectActivo === 'activos') {
        base = base.filter(i => i.activo !== false)
      } else if (this.selectActivo === 'inactivos') {
        base = base.filter(i => i.activo === false)
      }

      // Filtro institución
      const hasId = base.length > 0 && Object.prototype.hasOwnProperty.call(base[0], 'institucionPatrocinadoraId')
      if (this.selectInstitucion) {
        if (hasId) {
          this.becas = base.filter(i => i.institucionPatrocinadoraId === this.selectInstitucion)
        } else {
          const instName = this.cmbInstituciones.find(x => x.institucionPatrocinadoraId === this.selectInstitucion)?.nombre || ''
          this.becas = base.filter(i => (i.institucionPatrocinadora || '') === instName)
        }
      } else {
        this.becas = base
      }

      this.calcularKPIs()
      this.calcularCharts()
    },

    calcularKPIs() {
      const all = this.becasAll || []
      const items = this.becas || []
      const uniq = (arr) => Array.from(new Set(arr.filter(Boolean)))

      this.kpi.total = all.length
      this.kpi.activos = items.filter(i => i.activo !== false).length
      this.kpi.inactivos = items.filter(i => i.activo === false).length
      this.kpi.instituciones = uniq(items.map(i => i.institucionPatrocinadora)).length
      this.kpi.carreras = uniq(items.map(i => i.carrera)).length
    },

    topNGroup(items, key, n = 8) {
      const map = new Map()
      for (const it of items) {
        const k = (it?.[key] || 'Sin dato').toString().trim() || 'Sin dato'
        map.set(k, (map.get(k) || 0) + 1)
      }
      const rows = Array.from(map.entries())
        .map(([label, value]) => ({ label, value }))
        .sort((a, b) => b.value - a.value)
        .slice(0, n)

      const max = rows[0]?.value || 0
      return rows.map((r) => ({
        ...r,
        pct: max ? Math.round((r.value / max) * 100) : 0
      }))
    },

    calcularCharts() {
      // Si hay institución seleccionada, "Top instituciones" deja de ser útil (sería 1 sola),
      // así que mostramos el top con base en lo filtrado (lo cual será 1) o puedes cambiarlo
      // para que siempre muestre el top del ciclo usando this.becasAll.
      this.chartInstituciones = this.topNGroup(
        this.becas,
        'institucionPatrocinadora',
        8
      )
      // Carreras: mostrar TODAS las que tienen becados (sin top)
  // Puedes ordenar por 'label' (alfabético) o por 'value' (cantidad desc).
  this.chartCarreras = this.groupAll(this.becas, 'carrera', 'value')
    },

  
  }
}
</script>

